import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    Paper,
    Grid,
    TextField,
    Select,
    FormControl,
    MenuItem,
} from '@material-ui/core';

//Components
import {
    Button,
} from 'devextreme-react';

import Collapse from '@material-ui/core/Collapse';

import { CustomBody } from './../shared/CustomBody';
import { FormContainer } from './../shared/FormContainer';

import FormFieldPK from './form/FormFieldPK';
import FormFieldSN from './form/FormFieldSN';
import FormFieldMultiAzienda from './form/FormFieldMultiAzienda';
import FormFieldCodiceUtente from './form/FormFieldCodiceUtente';
import FormFieldDataScadenza from './form/FormFieldDataScadenza';

import ConfirmationDialog from './../shared/ConfirmationDialog';
import ActionProgress from './../shared/ActionProgress';
import Progress from './../shared/Progress';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    paperMain: {
        padding: '10px',
        textAlign: 'center',
        minHeight: "450px",
        position: 'relative',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    formField: {
        minWidth: '100%',
    },
    dividerButton: {
        borderTop: '1px solid #ddd',
        marginTop: '20px',
        padding: '20px !important'
    },
    formContainer: {
        paddingTop: '20px'
    },
});

class CreaLicenzaCmp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            validateAll: false,
            isOpen: false
        };

        this.changeAndValidateField = this.changeAndValidateField.bind(this);

        this.showDialog = this.showDialog.bind(this);

        this.salvaLicenza = this.salvaLicenza.bind(this);
    }

    componentDidMount() {
        // se non è admin, setto direttamente codice_utente dell'utente loggato
        if (this.props.codiceUtente !== 'CODICEADMIN')
            this.props.initializeField('codice_utente', this.props.codiceUtente);
    }

    componentDidUpdate(propsPrecedenti) {

        // quando genero un product_key aggiungo il valore generato su new_license.pk 
        if (this.props.product_key !== propsPrecedenti.product_key) {
            this.props.handleChangeField('pk', this.props.product_key);
            this.props.validateField('pk');
        }

        if (this.props.new_license.sn !== propsPrecedenti.new_license.sn) {
            this.props.validateSN(this.props.is_sn_valid);
        }

        if (this.props.is_sn_valid !== propsPrecedenti.is_sn_valid) {
            this.props.validateSN(this.props.is_sn_valid);
        }

    }

    showDialog() {
        this.setState({ isOpen: !this.state.isOpen });
    }

    changeAndValidateField(field, newValue) {
        this.props.handleChangeField(field, newValue);
        this.props.validateField(field);
    }

    changeAndValidateSN(newValue) {
        const { new_license, handleChangeField, checkSN, validateSN } = this.props;

        handleChangeField('sn', newValue);
        checkSN(newValue, new_license.tipologia);
        validateSN(this.props.is_sn_valid);
    }

    // se la creazione licenza è andata a buon fine ritorno a GridLicenze e resetto i valori di new_license
    clearAll() {
        const { new_license, sendLicenseDetails, resetCreateLicense, changeViewSelection, initializeFieldModuli } = this.props;

        //invio email con i dettagli della licenza creata
        sendLicenseDetails(new_license.pk, new_license.email);

        //setup per il passaggio alla view 'Gestione Moduli'
        initializeFieldModuli('prima_attivazione', true);
        initializeFieldModuli('product_key', new_license.pk);
        initializeFieldModuli('tipologia', new_license.tipologia);

        changeViewSelection('Gestione Moduli');

        resetCreateLicense();
    }

    salvaLicenza() {
        this.props.validateField('all');

        if (this.props.isChanged && this.props.isValid) {
            this.showDialog();
        }

    }

    render() {
        const { classes, new_license, errorText, codici_utente, initializeField, genPK,
            genSN, handleChangeFieldSN, sn_due_cifre, sn_quattro_cifre,
            isChanged, isValid, saveLicense, saveLicenseRequestStatus, saveLicenseErrorMessage, codiceUtente } = this.props;
        const { isOpen } = this.state;

        return (
            <Fragment>
                <Collapse in={this.props.newLicenseDataRequestStatus === 'RESOLVED'} timeout={2000}>
                    <Paper className={classes.paperMain}>
                        <CustomBody>
                            <Grid container spacing={3} className={classes.formContainer} >

                                <FormContainer labelText="Tipologia">
                                    <FormControl
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    >
                                        <Select
                                            className={classes.formField}
                                            value={new_license.tipologia}
                                            onChange={e => this.changeAndValidateField('tipologia', e.target.value)}
                                        >
                                            <MenuItem value={'Enterprise'}>Enterprise</MenuItem>
                                            <MenuItem value={'ERP'}>ERP</MenuItem>
                                        </Select>
                                    </FormControl>
                                </FormContainer>


                                <FormContainer labelText="Product Key">
                                    <FormFieldPK
                                        value={new_license.pk}
                                        genPK={genPK}
                                        onPKChange={e => this.changeAndValidateField('pk', e.target.value)}
                                        helperText={errorText.pk}
                                    />
                                </FormContainer>


                                <FormContainer labelText="Serial Number">
                                    <FormFieldSN
                                        value={new_license.sn}
                                        onSNChange={e => this.changeAndValidateSN(e)}
                                        handleChangeFieldSN={handleChangeFieldSN}
                                        initializeField={initializeField}
                                        genSN={genSN}
                                        sn_due_cifre={sn_due_cifre}
                                        sn_quattro_cifre={sn_quattro_cifre}
                                        helperText={errorText.sn}
                                        codiceUtente={codiceUtente}
                                    />
                                </FormContainer>

                                { // se è admin faccio scegliere il codice utente
                                    codiceUtente === 'CODICEADMIN' &&
                                    <FormContainer labelText="Codice Utente">
                                        <FormFieldCodiceUtente
                                            value={new_license.codice_utente}
                                            onCodiceUtenteChange={e => this.changeAndValidateField('codice_utente', e.target.value)}
                                            helperText={errorText.codice_utente}
                                            codici_utente={codici_utente}
                                        />
                                    </FormContainer>
                                }


                                <FormContainer labelText="MultiAzienda">
                                    <FormFieldMultiAzienda
                                        valueMultiAzienda={new_license.multiazienda}

                                        valueCodiceAzienda={new_license.codice_azienda}
                                        helperText={errorText.codice_azienda}

                                        manageChangeFormField={(field, newValue) => this.changeAndValidateField(field, newValue)}
                                    />
                                </FormContainer>


                                <FormContainer labelText="Cliente">
                                    <TextField
                                        className={classes.formField}
                                        variant="outlined"
                                        size="small"
                                        label="Cliente"
                                        value={new_license.cliente}
                                        helperText={errorText.cliente}
                                        onChange={e => this.changeAndValidateField('cliente', e.target.value)}
                                    />
                                </FormContainer>


                                <FormContainer labelText="Email">
                                    <TextField
                                        className={classes.formField}
                                        variant="outlined"
                                        size="small"
                                        label="Email"
                                        value={new_license.email}
                                        error={errorText.email !== '' ? true : false}
                                        helperText={errorText.email}
                                        onChange={e => this.changeAndValidateField('email', e.target.value)}
                                    />
                                </FormContainer>


                                <FormContainer labelText="Data Scadenza">
                                    <FormFieldDataScadenza
                                        value={new_license.data_scadenza}
                                        hasScadenza={new_license.hasScadenza}
                                        setScadenza={e => this.changeAndValidateField('hasScadenza', e)}
                                        helperText={errorText.data_scadenza}

                                        onDataScadenzaChange={e => this.changeAndValidateField('data_scadenza', e)}
                                    />
                                </FormContainer>


                                <Grid item xs={12} className={`${classes.alignCenter} ${classes.dividerButton}`}>
                                    <Button
                                        width={120}
                                        text="Salva"
                                        type="default"
                                        stylingMode="contained"
                                        disabled={((!isChanged) || !isValid) ? true : false}
                                        onClick={() => this.salvaLicenza()}
                                    />
                                </Grid>

                                <ConfirmationDialog
                                    isOpen={isOpen}
                                    showDialog={this.showDialog}
                                    title={"Crea Licenza"}
                                    message={"Confermi di voler creare una nuova licenza con i dati inseriti?"}
                                    action={() => saveLicense(this.props.new_license)}
                                />
                            </Grid>
                        </ CustomBody>

                        <ActionProgress
                            status={saveLicenseRequestStatus}
                            errorMessage={saveLicenseErrorMessage}
                            tryAgainAction={() => saveLicense(this.props.new_license)}
                            afterResolvedAction={() => this.clearAll()}
                        />
                    </Paper>
                </Collapse>

                <Collapse in={this.props.newLicenseDataRequestStatus !== 'RESOLVED'} timeout={500}>
                    <Paper className={classes.paperMain}>
                        <Progress
                            status={this.props.newLicenseDataRequestStatus}
                            cancelAction={() => this.clearAll()}
                            tryAgainAction={() => this.props.initializeNewLicenseData(new Date().getFullYear().toString().substr(-2))}
                            errorMessage='Errore del servizio. Impossibile ricevere dati per la creazione di una nuova licenza.'

                        />
                    </Paper>
                </Collapse >

            </Fragment>
        );

    }
}

CreaLicenzaCmp.propTypes = {
    //saveLicense
    saveLicense: PropTypes.func.isRequired,
    saveLicenseRequestStatus: PropTypes.string.isRequired,
    saveLicenseErrorMessage: PropTypes.string,
    isInserted: PropTypes.string.isRequired,

    //sendLicenseDetails
    sendLicenseDetails: PropTypes.func.isRequired,
    sendLicenseDetailsStatus: PropTypes.string.isRequired,
    sendLicenseDetailsErrorMessage: PropTypes.string,
    isSent: PropTypes.string.isRequired,


    new_license: PropTypes.shape({}).isRequired,

    //createLicenseData
    initializeNewLicenseData: PropTypes.func.isRequired,
    newLicenseDataRequestStatus: PropTypes.string.isRequired,

    codici_utente: PropTypes.arrayOf(PropTypes.string).isRequired,

    initializeField: PropTypes.func.isRequired,
    handleChangeField: PropTypes.func.isRequired,
    validateField: PropTypes.func.isRequired,
    validateSN: PropTypes.func.isRequired,

    //genSN
    genPK: PropTypes.func.isRequired,
    handleChangeFieldSN: PropTypes.func.isRequired,
    genPKRequestStatus: PropTypes.string.isRequired,
    product_key: PropTypes.string.isRequired,

    //genSN
    genSN: PropTypes.func.isRequired,
    genSNRequestStatus: PropTypes.string.isRequired,
    sn_due_cifre: PropTypes.string.isRequired,
    sn_quattro_cifre: PropTypes.string.isRequired,

    //checkSN
    checkSN: PropTypes.func.isRequired,
    checkSNRequestStatus: PropTypes.string.isRequired,
    is_sn_valid: PropTypes.bool.isRequired,

    //manageModuli
    initializeFieldModuli: PropTypes.func.isRequired,

    resetCreateLicense: PropTypes.func.isRequired,
    changeViewSelection: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};

export default withStyles(styles)(CreaLicenzaCmp);